import { toJSON } from '@rehaje/shared'

import { UnknownSchema } from '../../constants'
import { SchemaDefinition } from '../../models/SchemaDefinition'

import type { SchemaAnySpecific, TypedSchema } from '../../types'

export class SchemaAnyDefinition extends SchemaDefinition {
  override defaultsMerge(
    value: any,
    schema: SchemaAnySpecific,
    initialize: boolean
  ) {
    if (initialize) {
      if (value === undefined) return schema.default
      return value
    }
    if (schema.required && value === undefined) {
      return schema.default
    }
    return value
  }

  override getIn(schema: SchemaAnySpecific, path: PropertyKey[]) {
    if (path.length === 0) return schema
    return UnknownSchema
  }

  override infer(target: any, schema: SchemaAnySpecific): TypedSchema {
    return { ...schema, ...super.inferShapeSchema(target) } as TypedSchema
  }

  override inferOnlySchema(schema: SchemaAnySpecific) {
    return schema
  }

  override inferTypeScript(schema: SchemaAnySpecific): string {
    const value = schema.value
    if (value !== undefined) return JSON.stringify(toJSON(value))
    return 'any'
  }

  override prune(target: any): any {
    return target
  }

  override transform(target: any, schema: SchemaAnySpecific) {
    if (target === null && schema.nullable) return target
    if (target === undefined) return schema.fallback
    return target
  }

  override validate(target: any, schema: SchemaAnySpecific): void {
    this.validateMetadata(target, schema)
  }
}
